




















































import { Component, Vue, Prop } from "vue-property-decorator";
import { postProcessMagicLink } from "../api";
import Card from "./Card.vue";
import { namespace } from "vuex-class";

const authStore = namespace("auth");

@Component({
  components: { Card },
})
export default class LoginProcessCard extends Vue {
  @authStore.Action setLoggedIn!: (state: boolean) => Promise<void>;
  @authStore.Getter postLoginUrl!: string;

  @Prop({ required: true })
  token!: string;

  @Prop({ required: true })
  suffix!: string;

  pending = true;
  success = false;
  tokenSuffix = "";

  async processToken(): Promise<void> {
    try {
      await postProcessMagicLink(this.token);
      this.success = true;
      this.setLoggedIn(true);
      if (this.postLoginUrl) this.$router.push(this.postLoginUrl);
    } catch (e) {
      this.success = false;
    }
    this.pending = false;
  }

  async tokenRedirect(): Promise<void> {
    const tokenPrefix = this.token.slice(0, -this.suffix.length);
    const token = tokenPrefix + this.tokenSuffix;
    const suffix = this.tokenSuffix;
    this.$router.replace({
      name: "login-process-token",
      params: { token, suffix },
    });
  }

  mounted(): void {
    this.processToken();
  }
}
